import { MenuItem, TextField } from '@mui/material';
import { TIMEZONES_BRASIL } from '../../lib/timezones-brasil';

interface Props {
  valor: string;
  onChange: (v: string) => void;
  label?: string;
  helperText?: string;
}

/**
 * Select de fuso horário com timezones brasileiras. Persiste como string
 * IANA (ex.: `"America/Sao_Paulo"`) — formato esperado pelo backend.
 */
export function TimezoneSelect({ valor, onChange, label = 'Fuso horário', helperText }: Props): JSX.Element {
  // Se o valor atual não está na lista (custom/legado), preserva como item extra.
  const valorCustom = !TIMEZONES_BRASIL.some((t) => t.valor === valor) && valor ? valor : null;

  return (
    <TextField
      select
      label={label}
      value={valor}
      onChange={(e) => onChange(e.target.value)}
      helperText={helperText}
      fullWidth
    >
      {valorCustom && (
        <MenuItem value={valorCustom}>
          {valorCustom} <span style={{ opacity: 0.6, marginLeft: 8 }}>(custom)</span>
        </MenuItem>
      )}
      {TIMEZONES_BRASIL.map((t) => (
        <MenuItem key={t.valor} value={t.valor}>
          {t.rotulo}{' '}
          <span style={{ opacity: 0.6, marginLeft: 8, fontSize: 12 }}>{t.utc}</span>
        </MenuItem>
      ))}
    </TextField>
  );
}
